import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { GlassCard } from '@/components/shared/redesign';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

export interface StatsCardProps {
  title: string;
  value: number | string;
  /** Accent color used to tint the icon badge. Should be a semantic status or
   *  accent token from the caller's theme — caller decides the meaning. */
  color: string;
  /** Icon node rendered inside the colored badge — typically an SVG sized 16×16. */
  icon: React.ReactNode;
}

export const StatsCard: React.FC<StatsCardProps> = ({ title, value, color, icon }) => {
  const styles = useStyles();

  return (
    <GlassCard padding={16} style={styles.statsCard}>
      <View style={styles.statsCardHeader}>
        <View style={[styles.statsCardIcon, { backgroundColor: color }]}>
          {icon}
        </View>
        <Text style={styles.statsCardTitle}>{title}</Text>
      </View>
      <Text style={styles.statsCardValue}>{value}</Text>
    </GlassCard>
  );
};

const useStyles = () =>
  useThemedStyles(({ components, colors }) => {
    const admin = components.admin;
    return StyleSheet.create({
      statsCard: {
        flex: 1,
      },
      statsCardHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
      },
      statsCardIcon: {
        width: 28,
        height: 28,
        borderRadius: 14,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 8,
      },
      statsCardTitle: {
        fontSize: 14,
        fontWeight: '500',
        color: colors.text.dim,
      },
      statsCardValue: {
        fontSize: 28,
        fontWeight: '700',
        color: admin.dataTable.text,
      },
    });
  });
